import React, { useEffect } from "react";
import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import "../assets/style.css";
import CssBaseline from "@material-ui/core/CssBaseline";
import Header from "./header/index";
import Footer from "./footer/index";
import { theme } from "./theme";
import { withCookies } from "react-cookie";
import { v4 as uuidv4 } from "uuid";
const Layout = (props) => {
  useEffect(() => {
    if (!props.cookies.get("tsa_cart")) {
      props.cookies.set("tsa_cart", uuidv4());
    }
  }, [props]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Header headerStyle={props.headerStyle} />
        <main
          style={{
            minHeight: "90vh",
            overflowX: "hidden",
            paddingTop: 55,
            background: "#fff",
          }}
        >
          {props.children}
        </main>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default withCookies(Layout);
